import * as React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";
import { Helmet } from "react-helmet";

//CUSTOM COMPONENT
import Area from "../../../aGlobalDesign/Area/Area";
import PaginationList from "../../../aGlobalDesign/Pagination/PaginationList";
import ButtonSkaRound from "../../../aGlobalDesign/Buttons/ButtonSkaRound";
import Modal from "../../../aGlobalDesign/Modal/Modal";
import ShowCountSKA from "../../../aGlobalDesign/Buttons/ShowCountSKA";

class ZonesList extends React.Component {

    constructor() {
        super();
        this.state = {
            searchField: "",
            forcePaginationUpdate: 0,
            temporaryElement: null,
            selectedZone: null
        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.Zones);
        this.props.ChangeCurrentMenuName("Zones");
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            selectedZone: null,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.reload && this.props.reload !== prevProps.reload) {
            this.forcePaginationUpdate();
        }
        if (this.props.createNew !== prevProps.createNew) {
            this.OnLoadZoneClick(null);
        }
    }

    //#region function
    OnLoadZoneClick(zone) {
        let ar = zone;
        if (ar === null) {
            ar = {
                id: 0,
                name: "",
                description: ""
            };
        }
        const temp = this.CreateTemp(ar);
        this.setState({
            selectedZone: ar,
            temporaryElement: temp
        });
    }
    CreateTemp(element) {
        const temp = {
            id: element.id,
            name: element.name,
            description: element.description
        };
        return temp;
    }
    SaveTemp(temp, element) {
        element.name = temp.name;
        element.description = temp.description;
        return element;
    }
    OnSaveChangeZone() {
        const changedZone = this.state.selectedZone;
        this.SaveTemp(this.state.temporaryElement, changedZone);
        changedZone.organizationId = this.props.currentuser.currentorganization.id;
        changedZone.organization = null;

        if (changedZone.id === 0) {
            //send to DB
            this.props.CreateZone(changedZone, (data) => {
                this.forcePaginationUpdate();
                this.props.GetSecondaryZonesList();
            });
        }
        else {
            //Save changes on DB
            this.props.EditZone(changedZone, (changedZoneTimestamp) => {
                this.forcePaginationUpdate();
                this.props.GetSecondaryZonesList();
            });
        }
    }
    //#endregion

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        return <>
            <PaginationList
                forcePaginationUpdate={this.state.forcePaginationUpdate}

                onGetElements={this.props.GetZonesList}
                onSavePagination={this.props.SaveZonesPagination}
                myElements={this.props.administration.zones}

                sortOptions={[
                    { sortName: "name", sortData: "asc" },
                    { sortName: "description", sortData: "null" },
                    { sortName: "decisionTrees", sortData: "null" },
                    { sortName: "portalClients", sortData: "null" }
                ]}

                tableElement={(element) => {
                    return [
                        {
                            colTitle: strings.SortName,
                            fixedWidth: "300px",
                            colContent: element ? element.name : null
                        },
                        {
                            colTitle: strings.Description,
                            sortIndex: 1,
                            fixedWidth: "300px",
                            colContent: element ? element.description : null
                        },
                        {
                            colTitle: strings.SortDecisionsTree,
                            sortIndex: 2,
                            fixedWidth: "300px",
                            colContent: element && element.decisionTrees.length > 0 ? element.decisionTrees[0].name : null
                        },
                        {
                            colTitle: strings.SortPortalsClient,
                            sortIndex: 3,
                            fixedWidth: "200px",
                            lockWidth: true,
                            justify: "center",
                            cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                const value = data[column.field];
                                if (value) {
                                    return <ShowCountSKA list={value.portalClients.map((ag) => {return " " + ag.name;})} count={value.portalClients.length} spaceWithCount={[0, -50]} />;
                                }
                                else {return "";}
                            },
                            colContent: element ? { portalClients: element.portalClients } : null
                        },
                        {
                            colTitle: strings.actions,
                            colType: "actions",
                            actions: [1, 2, 3],
                            colContent: [
                                <ButtonSkaRound
                                    key={"view"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(50, "consult") <= 10}
                                    onClick={() => {
                                        this.setState({ preview: true });
                                        this.OnLoadZoneClick(element);
                                    }}
                                    nameIcon="eye"
                                />,
                                <ButtonSkaRound
                                    key={"edit"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(50, "modify") <= 10}
                                    onClick={() => this.OnLoadZoneClick(element)}
                                    nameIcon="edit"
                                />,
                                <ButtonSkaRound
                                    key={"trash"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(50, "delete") <= 10}
                                    onClick={() => {
                                        this.props.OpenDialog({
                                            title: strings.deleteConfirm,
                                            description: strings.textDeleteItem,
                                            secondaryLabel: strings.cancel,
                                            primaryLabel: strings.confirmDelete,
                                            onPrimaryAction: () => {
                                                this.props.DeleteZone(element.id, () => {
                                                    this.forcePaginationUpdate();
                                                    this.props.GetSecondaryZonesList();
                                                    //we refresh the concerned lists to avoid exeptions
                                                    if (this.props.administration.secondaryusers) {
                                                        this.props.GetSecondaryUsersList((data) => {});
                                                    }
                                                    if (this.props.administration.users) {
                                                        this.props.GetUsersList(1, 20, "", "", "", "Table", (data) => {});
                                                    }
                                                    if (this.props.administration.invitations) {
                                                        this.props.GetInvitationsList(1, 20, "", "", "", "Table", (data) => {});
                                                    }
                                                    if (this.props.monitoring.displays) {
                                                        this.props.GetDisplaysList(1, 20, "", "", "", "Table", (data) => {});
                                                    }
                                                });
                                            }
                                        });
                                    }}
                                    nameIcon="trash"
                                />
                            ]
                        }
                    ];
                }}
            />
            <Modal open={this.state.selectedZone !== null}
                onClose={() => {
                    if (!this.state.preview) {
                        this.forcePaginationUpdate();
                    }
                    else {
                        this.setState({
                            selectedZone: null,
                            preview: false
                        });
                    }
                }}
                disableValidate={this.state.temporaryElement === null || this.state.temporaryElement.name === null || this.state.temporaryElement.name === "" || this.state.temporaryElement.description === null || this.state.temporaryElement.description === ""}
                title={this.state.preview ? strings.infoZone : this.state.selectedZone && this.state.selectedZone.id !== 0 ? strings.editZone : strings.CreateNewZone}
                icon={this.state.preview ? "information" : this.state.selectedZone && this.state.selectedZone.id !== 0 ? "edit" : "add"}
                validationIcon={"save"}
                validationTitle={strings.register}
                fields={
                    this.state.temporaryElement ? [
                        {
                            type: "textfield",
                            title: strings.name,
                            disabled: this.state.preview,
                            error: this.state.temporaryElement.name === "",
                            value: this.state.temporaryElement.name,
                            onChange: (e) => {
                                const dp = this.state.temporaryElement;
                                dp.name = e.target.value;
                                this.setState({ temporaryElement: dp });
                            }
                        },
                        {
                            type: "textfield",
                            title: strings.descriptif,
                            disabled: this.state.preview,
                            value: this.state.temporaryElement.description,
                            onChange: (e) => {
                                const dp = this.state.temporaryElement;
                                dp.description = e.target.value;
                                this.setState({ temporaryElement: dp });
                            }
                        }
                    ] : null
                }
                onValidate={ this.state.preview ? null : () => this.OnSaveChangeZone()}
            >
            </Modal>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default withRouter(connect(
    (state) => state,
    mapDispatchToProps
)(ZonesList));
